export default "__VITE_ASSET__DGM3pTRL__"